var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet-workpackage-rework font-weight-light",style:(`
    ${_vm.selected
      ?
        `position: fixed;
        padding: 0px 0px 0px 0px;
        border-radius: 10px;
        top: ${_vm.$vuetify.breakpoint.smAndDown?'3px':'84px'};
        z-index: 100;
        height: ${_vm.$vuetify.breakpoint.smAndDown?`calc(${_vm.mobile_height}px - 6px)`:'calc(100vh - 117px)'};
        width: ${!_vm.$vuetify.breakpoint.smAndDown?'calc((100vw - 50px) / 3 - 20px)':'calc(100vw - 20px)'};`
      :
        `z-index: 0;
        width: ${!_vm.$vuetify.breakpoint.smAndDown?'calc((100vw - 50px) / 3 - 20px)':'calc(100vw - 20px)'};`
    }
    ${_vm.index === _vm.count - 1 && !_vm.selected
      ? 'margin-bottom: -25px;'
      : ''
    }
    ${_vm.index !== 0 && !_vm.selected && !_vm.is_show_status_popup
      ? 'margin-top: -10px;'
      : ''
    }
    ${!_vm.selected && _vm.is_show_status_popup
      ? (_vm.index !== 0
        ? 'margin-top: -70px;'
        : 'margin-top: -60px;')
      : ''
    }
  `)},[_c('div',{class:`wallet-workpackage-rework-header-slot${_vm.selected}`,style:(_vm.is_show_status_popup && !_vm.selected?'margin-bottom: 60px':'')},[_vm._t("header")],2),_c('div',{class:`wallet-workpackage-rework-body-slot${_vm.selected}`,style:(_vm.selected === '-selected'?(_vm.$vuetify.breakpoint.smAndDown?`height: calc(${_vm.mobile_height}px - 6px - 80px);`:'height: calc(100vh - 114px - 80px);'):'')},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }